import router from "./../router";
import { version as appVersion } from "../../package.json";
import globals from "../globals";
import feature from "../feature";
import { TextEncoder } from "text-encoding-shim";
import { keycloak } from "../main";

const SERVER_URL = process.auth.serverUrl;
const CLIENT_URL = process.auth.redirectUrl;

export default {
  // app wide variables
  tokenRenewalPending: false,
  tokenRenewalCallbacks: [],
  appReloadPending: false,
  
  accessToken: null,
  idToken: null,
  refreshToken: null,

  // app functions
  isJWTExpired(token) {
    let payload = this.getTokenData(token);
    let expireDate = payload.exp * 1000;
    let now = Date.now();
    return now > expireDate;
  },
  getTokenData(token) {
    if (!token) return;
    let data = JSON.parse(window.atob(token.split(".")[1]));
    return data;
  },
  getAccessToken() {
    return this.accessToken || null;
  },
  getRefreshToken() {
    return this.refreshToken || null;
  },
  getIdToken() {
    return this.idToken || null;
  },
  checkRouteValid(hash) {
    if (hash.length > 2) {
      var route = hash.slice(1);
      for (var r in router.options.routes) {
        var path = router.options.routes[r].path;
        if (path == route) return true;
      }
    }
    return false;
  },
  randomString(length) {
    let charset =
      "0123456789ABCDEFGHIJKLMNOPQRSTUVXYZabcdefghijklmnopqrstuvwxyz-._~";
    let result = "";

    while (length > 0) {
      let bytes = new Uint8Array(16);
      let crypto = window.crypto || window.msCrypto;
      let random = crypto.getRandomValues(bytes);
      random.forEach(function (c) {
        if (length == 0) {
          return;
        }
        if (c < charset.length) {
          result += charset[c];
          length--;
        }
      });
    }
    return result;
  },
  hexString(buffer) {
    const byteArray = new Uint8Array(buffer);

    const hexCodes = [...byteArray].map((value) => {
      const hexCode = value.toString(16);
      const paddedHexCode = hexCode.padStart(2, "0");
      return paddedHexCode;
    });

    return hexCodes.join("");
  },
  async digestMessage(message) {
    const encoder = new TextEncoder();
    const data = encoder.encode(message);
    let crypto = window.crypto || window.msCrypto;
    let result = await crypto.subtle.digest("SHA-256", data);
    if (result.result) result = result.result; // IE11 returns an object containing result property
    return result;
  },
  async digestMessageToHexString(message) {
    return this.hexString(await this.digestMessage(message));
  },
  directToLogin() {
  },
  redirectAfterLoginCallback() {
  },
  setClientTimeZone() {
    let tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if (!tz) return;
    let query = `api/SecurityUsers/Localization?TimeZoneName=${encodeURIComponent(
      tz
    )}`;

    $.ajax({
      method: "PUT",
      url: query,
      dataType: "json",
      contentType: "application/json; charset=utf-8",
      error: () => {
        console.error("Error on PUT in setClientTimeZone()");
        globals.showErrorSnackbar("Timezone update failed");
      },
    });
  },
  getDefaultAjaxSetupConfig() {
    return {
      headers: {
        Pragma: "no-cache",
      },
    };
  },
  configureAjaxSetup() {
    let access_token = this.getAccessToken();
    let config = this.getDefaultAjaxSetupConfig();
    config.headers.Authorization = `Bearer ${access_token}`;
    $.ajaxSetup(config);
  },
  initializeGlobalAjaxEvents() {
    if (!this.getRefreshToken && !this.tokenRenewalPending) {
      this.removeTokensFromStorage();
      this.directToLogin();
      return;
    }
    let access_token = this.getAccessToken();
    let config = this.getDefaultAjaxSetupConfig();
    if (access_token) config.headers.Authorization = `Bearer ${access_token}`;
    $.ajaxSetup(config);

    window.addEventListener("storage", (e) => {
      if (e.key === "refresh_token") {
        this.configureAjaxSetup();
      }
    });

    $(document).ajaxError((event, jqXHR) => {
      if (jqXHR.status === 401) {
        this.removeTokensFromStorage();
        window.location.reload();
      }
    })

    $(document).ajaxComplete((event, jqXHR, options, data) => {
      let apiVersion = jqXHR.getResponseHeader("frontend-version");
      let isDevSystem = feature.currentTarget.indexOf("dev") > -1;
      if (
        !isDevSystem &&
        !this.appReloadPending &&
        apiVersion &&
        apiVersion !== appVersion
      ) {
        this.appReloadPending = true;
        // Force hard reload of the page if a new version of the app is available
        console.error("Frontend version mismatch - reloading page");
        location.reload(true);
      }
    });
  },
  getPostLoginUrl() {
    let hashString = window.location.hash;
    let idx = hashString.indexOf("id_token");
    if (idx < 0) return "";

    let postLoginUrl = hashString.slice(2, idx);
    return postLoginUrl;
  },
  storeTokensInStorage(access_token, id_token, refresh_token) {
    this.accessToken = access_token;
    this.idToken = id_token;
    this.refreshToken = refresh_token;
    globals.$emit("accessTokenChanged");
  },
  removeTokensFromStorage() {
    this.accessToken = null;
    this.idToken = null;
    this.refreshToken = null;
    globals.$emit("accessTokenChanged");
  },
  getTokensFromUrl() {
    return;
  },
  logout() {
    keycloak.logout();
  },
};



// WEBPACK FOOTER //
// ./src/services/app.service.js